import React, { Component } from 'react';
import { Grid, TextField, Button } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FolderZipIcon from '@mui/icons-material/FolderZip';

class ComposeChatDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.isComposeChatOpen || false,
      userMessage: props.userMessage || ''
    };

    this.topSection = React.createRef();
    this.filePreview = React.createRef();
    this.inputField = React.createRef();
  }

  componentDidMount() {
    this.setState({
      userMessage: this.props.userMessage || ''
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.isComposeChatOpen !== this.props.isComposeChatOpen) {
      this.setState({ open: this.props.isComposeChatOpen });
    }
  }

  render() {
    const { fileName, fileType, fileSize, filePreview, fileTypeFormatted, image, video, document } =
      this.props;

    const styles = {
      composeChatContainer: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        top: 0,
        right: 0,
        backgroundColor: '#F2F2F2',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        overflow: 'hidden',
        margin: 0,
        padding: 12,
        zIndex: 9999999999,
        overflowY: 'auto',
        width: '100%'
      },
      closeIcon: {
        color: 'black',
        margin: '0 12px 0 12px',
        paddingRight: 12,
        filter: 'invert(100%)'
      },
      textfieldContainer: {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        width: '100%',
        backgroundColor: '#F2F2F2',
        zIndex: 1000,
        padding: '2px 0 0 0'
      },
      textField: {
        minHeight: 48,
        background: 'white',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        fontFamily: 'Manrope',
        fontWeight: 'normal',
        fontSize: 'clamp(0.6rem, 2vw, 1rem)',
        width: '100%'
      },
      submitButton: {
        minWidth: 48,
        minHeight: 48,
        background: '#2F98A3',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 4
      },
      fileName: {
        textAlign: 'left',
        color: 'black',
        fontSize: 16,
        fontFamily: 'Manrope',
        fontWeight: '600',
        wordWrap: 'break-word',
        backgroundColor: 'white',
        borderRadius: 20,
        padding: 12,
        width: '100%',
        display: 'flex',
        flexGrow: 1
      },
      filePreviewContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: 12,
        maxWidth: '50%',
        maxHeight: '50%'
      },
      filePreviewImage: {
        width: '100%',
        height: 'auto',
        borderRadius: 20,
        backgroundColor: 'white',
        padding: 12,
        border: '0.5px #2F98A3 solid'
      },
      filePreviewVideo: {
        maxWidth: 300,
        height: 'auto',
        borderRadius: 20,
        backgroundColor: 'white',
        padding: 12,
        border: '0.5px #2F98A3 solid'
      },
      filePreviewDocument: {
        width: '100%',
        minWidth: 300,
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'white',
        borderRadius: 20,
        border: '0.5px #2F98A3 solid',
        padding: 12
      },
      filePreviewDetails: {
        wordWrap: 'nowrap',
        textAlign: 'left',
        color: 'black',
        fontSize: 16,
        fontFamily: 'Manrope',
        fontWeight: 'light',
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
      },
      filePreviewFileName: {
        color: 'black',
        fontSize: 16
      },
      filePreviewFileType: {
        color: 'black',
        fontSize: 12,
        marginRight: 6
      },
      filePreviewFileSize: {
        color: 'black',
        fontSize: 12
      }
    };

    return (
      <>
        <div style={styles.composeChatContainer}>
          {/* Top Section */}
          <Grid
            ref={this.topSection}
            container
            style={{ alignItems: 'center', marginBottom: '12px' }}
          >
            <Grid item xs={1} sm={1} style={{ display: 'flex', justifyContent: 'center' }}>
              <img
                onClick={() => this.props.onClose()}
                src="/app-icons/chevron-left.svg"
                alt="Return to Task Messages"
                style={styles.closeIcon}
              />
            </Grid>
            <Grid item xs={10} sm={10}>
              <div style={styles.fileName}>{fileName}</div>
            </Grid>
          </Grid>

          {/* File Preview */}
          <Grid
            ref={this.filePreview}
            style={{
              maxWidth: '100%',

              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginBottom: '12px'
            }}
          >
            <div style={styles.filePreviewContainer}>
              {(() => {
                if (image.includes(fileType)) {
                  return <img src={filePreview} alt={fileName} style={styles.filePreviewImage} />;
                } else if (video.includes(fileType)) {
                  return <video controls src={filePreview} style={styles.filePreviewVideo} />;
                } else if (document.includes(fileType)) {
                  let icon = (
                    <img
                      src="/app-icons/document.svg"
                      alt="Document Icon"
                      style={{ width: 70, marginRight: 12, filter: 'invert(100%)' }}
                    />
                  );
                  if (fileTypeFormatted === 'PDF') {
                    icon = (
                      <PictureAsPdfIcon style={{ color: 'black', fontSize: 70, marginRight: 12 }} />
                    );
                  } else if (fileTypeFormatted === 'ZIP') {
                    icon = (
                      <FolderZipIcon style={{ color: 'black', fontSize: 70, marginRight: 12 }} />
                    );
                  }
                  return (
                    <div style={styles.filePreviewDocument}>
                      {icon}
                      <div style={styles.filePreviewDetails}>
                        <span style={styles.filePreviewFileName}>{fileName}</span>
                        <div style={{ gap: 5 }}>
                          <span style={styles.filePreviewFileType}>{fileTypeFormatted}</span>
                          <span style={{ marginRight: 6 }}>&middot;</span>
                          <span style={styles.filePreviewFileSize}>{fileSize}</span>
                        </div>
                      </div>
                    </div>
                  );
                }
              })()}
            </div>
          </Grid>

          {/* Input Field */}
          <Grid container alignItems="center" justifyContent="space-between">
            <div ref={this.inputField} style={styles.textfieldContainer}>
              <TextField
                style={styles.textField}
                placeholder="Message"
                value={this.state.userMessage}
                multiline
                inputProps={{ style: { color: 'black' } }}
                onChange={(e) => this.setState({ userMessage: e.target.value })}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && this.state.userMessage !== '') {
                    e.preventDefault();

                    this.props.sendMessage(this.state.userMessage);
                    this.props.onClose();
                  }
                }}
              />

              <Button
                style={styles.submitButton}
                type="submit"
                onClick={() => {
                  this.props.sendMessage(this.state.userMessage);
                  this.props.onClose();
                }}
              >
                <img src="/app-icons/send.svg" alt="Send" />
              </Button>
            </div>
          </Grid>
        </div>
      </>
    );
  }
}

export default ComposeChatDialog;
